import { render } from "./assign-access-partner.vue?vue&type=template&id=4c627680"
import script from "./assign-access-partner.vue?vue&type=script&setup=true&lang=js"
export * from "./assign-access-partner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/assign-access-partner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c627680"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c627680', __exports__)) {
    console.log('reload')
    api.reload('4c627680', __exports__)
  }
  
  module.hot.accept("./assign-access-partner.vue?vue&type=template&id=4c627680", () => {
    console.log('re-render')
    api.rerender('4c627680', render)
  })

}


export default __exports__